import React, { Component } from "react";
import PropTypes from "prop-types";
import moment from "moment";
import { Link } from "react-router-dom";

class SentRVM extends Component {
  static propTypes = {
    rvm: PropTypes.object
  };

  render() {
    let statusLabel =
      this.props.rvm.status == "OK" ? "label-success" : "label-default";
    return (
      <div className="m-b-40">

        <div className="form-group">
          <label>Sent At</label>
          <input
            type="text"
            className="form-control rvm_template_created_at_field"
            disabled="disabled"
            value={moment(this.props.rvm.created_at).format("MM/DD/YYYY h:mm:ss A")}
          />
        </div>

        <div className="form-group">
          <label>Delivered At</label>
          { this.props.rvm.delivery_time &&
            <input
              type="text"
              className="form-control rvm_template_delivery_time_field"
              disabled="disabled"
              value={moment(this.props.rvm.delivery_time).format("MM/DD/YYYY h:mm:ss A")}
            />
          }
        </div>

        <div className="form-group">
          <label>Status</label>
          <span className={`label m-l-10 ${statusLabel}`}>{this.props.rvm.status}</span>
        </div>

        <div className="form-group">
          <label>Reason for failure</label>
          <input
            type="text"
            className="form-control rvm_template_reason_for_failure_field"
            disabled="disabled"
            value={this.props.rvm.reason_for_failure}
          />
        </div>

        <div className="form-group">
          <label>Carrier</label>
          <input
            type="text"
            className="form-control rvm_template_carrier_field"
            disabled="disabled"
            value={this.props.rvm.carrier}
          />
        </div>

        <div className="form-group">
          <label>To</label>
          <input
            type="text"
            className="form-control to_field"
            disabled="disabled"
            value={this.props.rvm.phone}
          />
        </div>

        <div className="form-group">
          <label>First Name</label>
          <input
            type="text"
            className="form-control first_name_field"
            disabled="disabled"
            value={this.props.rvm.first_name}
          />
        </div>

        <div className="form-group">
          <label>Last Name</label>
          <input
            type="text"
            className="form-control last_name_field"
            disabled="disabled"
            value={this.props.rvm.last_name}
          />
        </div>

        <div className="form-group">
          <label>Template</label>
          <Link
            to={`/rvm_templates/${this.props.rvm.rvm_template_id}`}
            className="m-l-10"
          >
            {this.props.rvm.rvm_template_name}
          </Link>
        </div>

      </div>
    );
  }
}

export default SentRVM;
